/**
 * Affiliate link helpers (inlined from @designwithfriends/link-affiliater).
 */

export function toAffiliated(directUrl) {
  try {
    const urlObject = new URL(directUrl);
    switch (urlObject.hostname) {
      case "www.minted.com":
        return `https://shareasale.com/r.cfm?b=120126&u=1653604&m=17025&urllink=${encodeURIComponent(directUrl)}`;
      case "www.amazon.com":
        urlObject.searchParams.set("tag", "designwithf0e-20");
        return urlObject.href;
      case "www.etsy.com":
        return `https://www.awin1.com/cread.php?awinmid=10690&awinaffid=516467&clickref=&p=${encodeURIComponent(directUrl)}`;
      case "www.homedepot.com":
        return `https://homedepot.sjv.io/c/1242384/459920/8154?u=${encodeURIComponent(directUrl)}`;
      case "www.walmart.com":
        return `https://goto.walmart.com/c/1242384/565706/9383?veh=aff&sourceid=imp_000011112222333344&u=${encodeURIComponent(directUrl)}`;
      case "c.affil.walmart.com": {
        const apiUrl = urlObject.searchParams.get("l");
        return `https://goto.walmart.com/c/1242384/565706/9383?veh=aff&sourceid=imp_000011112222333344&u=${encodeURIComponent((apiUrl || "").split("?")[0])}`;
      }
      case "www.houzz.com":
        return `https://www.anrdoezrs.net/click-8810109-13769002?url=${encodeURIComponent(directUrl)}`;
      case "www.projectnursery.com":
        return `https://shareasale.com/r.cfm?b=835104&u=1653604&m=64329&urllink=${encodeURIComponent(directUrl)}`;
      case "www.buybuybaby.com":
        return `https://www.anrdoezrs.net/links/8810109/type/dlg/${directUrl}`;
      default:
        throw new Error("link format is not supported");
    }
  } catch (e) {
    console.error(`Trying to get the affiliate link for an invalid url: ${directUrl}`);
    return null;
  }
}
